import { getFullPath, routes } from "../../routes";
import { Link } from "react-router-dom";
import { useConfiguration } from "@/queries/configuration.queries";
import { useLogin } from "@/hooks";
import { WilliamsUserAccessLevel } from "../../users";

export function WilliamsHeaderLinks() {
  const configuration = useConfiguration();
  const { logout } = useLogin();

  function onLogout(e: React.MouseEvent) {
    e.preventDefault();
    logout();
  }

  return (
    <>
      <Link className="header-top-info__link" to={getFullPath(routes.miscellaneous.help)}>
        <span>Help</span>
      </Link>
      <Link className="header-top-info__link" to={getFullPath(routes.miscellaneous.settings)}>
        <span>Settings</span>
      </Link>
      <a className="header-top-info__link" href="#" onClick={onLogout}>
        <span>Logout ({configuration.data?.currentUser})</span>
      </a>
      <span className="header-top-info__text">
        <WilliamsUserAccessLevel />
      </span>
    </>
  );
}
